'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
var MastheadExtensionWidgets = function MastheadExtensionWidgets(_ref) {
    var widgets = _ref.widgets,
        theme = _ref.theme;

    var keys = (0, _keys2.default)(widgets);

    if (keys.length === 0) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.widgets },
        keys.map(function (key) {
            var Widget = widgets[key];
            return _react2.default.createElement(Widget, { key: key });
        })
    );
};

if (process.env.NODE_ENV !== 'production') {
    MastheadExtensionWidgets.propTypes = {
        widgets: _propTypes2.default.shape({
            WeatherWidget: _propTypes2.default.func
        }),
        theme: _propTypes2.default.shape({
            widgets: _propTypes2.default.string
        })
    };
}

MastheadExtensionWidgets.defaultProps = {
    widgets: {},
    theme: {}
};

exports.default = MastheadExtensionWidgets;
//# sourceMappingURL=MastheadExtensionWidgets.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionWidgets/MastheadExtensionWidgets.js
 ** module id = 327
 ** module chunks = 0
 **/